export default __webpack_public_path__ + "static/media/labor_scheduling.a6629701.png";